import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { Text } from "@/components/ui/baseUi/text"
import { boxProgramColors, type BoxProgramColorType } from "@/modules/boxProgrammation/components/boxProgramColors"
import { BoxProgramDefaultSettingsForm } from "@/modules/boxProgrammation/components/boxProgramDefaultSettingsForm"
import type { BoxProgramDefaultSettingsFormFields } from "@/modules/boxProgrammation/formik/boxProgramFormTypes"
import { QuadBoxIcon } from "@images/svgIcons/quadBoxIcon"
import styled from "styled-components"

export const BoxProgramDefaultSettingsFormView = withForm({
  defaultValues: {} as BoxProgramDefaultSettingsFormFields,
  props: {} as {
    boxProgramName: string
    boxProgramColor: BoxProgramColorType
    moveToPreviousFormStep: () => void
    onValidate: () => void
    isSubmitting: boolean
  } & React.ComponentProps<"div">,
  render: function BoxProgramDefaultSettingsFormViewInner({
    form,
    boxProgramName,
    boxProgramColor,
    onValidate,
    isSubmitting,
    moveToPreviousFormStep,
  }) {
    return (
      <div className="flex flex-col gap-6 px-5 pt-18 pb-6">
        <div className="flex items-center gap-2">
          <div className="ml-6 w-max">
            <QuadBoxIcon color="currentColor" className="text-textDefault-body" />
          </div>
          <Text fontStyle="HS">{boxProgramName}</Text>
          <div className="w-max">
            <ProgrammationColor $color={boxProgramColors[boxProgramColor].background} />
          </div>
        </div>

        <BoxProgramDefaultSettingsForm
          form={form}
          onValidate={onValidate}
          isSubmitting={isSubmitting}
          moveToPreviousFormStep={moveToPreviousFormStep}
        />
      </div>
    )
  },
})

const ProgrammationColor = styled.div<{ $color: string }>`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: ${({ $color }) => $color};
`
